var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCall = function SvgHelpCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#040222",
    d: "M11.811 4.575h.644a1.21 1.21 0 0 1 1.212 1.213v2.424a1.21 1.21 0 0 1-1.212 1.212h-.644A4.85 4.85 0 0 1 7 13.667v-1.212a3.636 3.636 0 0 0 3.637-3.637V5.182a3.637 3.637 0 1 0-7.274 0v4.242H1.545A1.21 1.21 0 0 1 .333 8.212V5.788a1.21 1.21 0 0 1 1.212-1.213h.644a4.85 4.85 0 0 1 9.622 0M1.545 5.788v2.424h.606V5.788zm10.304 0v2.424h.606V5.788zM4.43 9.294l.643-1.028A3.6 3.6 0 0 0 7 8.818a3.6 3.6 0 0 0 1.927-.552l.643 1.028A4.83 4.83 0 0 1 7 10.03a4.83 4.83 0 0 1-2.57-.736"
  })));
};
export default SvgHelpCall;